/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable react/prop-types,react/no-unused-state */
import React from 'react';
import { Breadcrumbs, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import {withUser} from '../../UserProvider';

export default withUser(({ user }) => ({
	scopes: user.scopes
}))(function StreamSheetBreadCrumbs(props) {
	const { path, openPage, workSpace } = props;

	const crumbs = path.split('/');
	const final = crumbs.pop();

	if (workSpace) {
		const wsName = props.scopes.find(scope => scope.id === workSpace);
		if (wsName) {
			crumbs.push(wsName.name);
		}
	}

	const open = (crumb) => {
		if (workSpace && crumb !== 'Apps') {
			openPage(`/apps#ws=/${props.workSpace}/`);
		} else {
			openPage(`/${crumb.toLowerCase()}`)
		}
	};

	return (
		<Breadcrumbs data-tour="breadcrumbs" sx={{ marginLeft: '17px', marginTop: '10px' }} aria-label="breadcrumb">
			{crumbs.map((crumb) => (
				<Button
					key={crumb}
					size="small"
					color="inherit"
					sx={[
						{ padding: '0px', minWidth: '0px', textTransform: 'none' },
						{ '&:hover': { textDecoration: 'underline' } }
					]}
					onClick={() => open(crumb)}
				>
					{crumb}
				</Button>
			))}
			<Typography
				sx={{
					fontSize: '0.69rem',
					lineHeight: '1.75',
					marginTop: '0px',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					maxWidth: '300px'
				}}
				color="text.primary"
			>
				{final || ' '}
			</Typography>
		</Breadcrumbs>
	);
});
